import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NumberService {

  constructor() { }

  /**
   * For the given instance of type <T>, return a new instance of type <T> with rounded number fields.
   * @param source The source model.
   * @param precision The number of significant digits.
   */
  roundModel<T>(source: any, precision: number): T {
    const roundedTarget = {
      ...source
    };

    // round number fields
    Object.keys(source)
      .filter((field) => typeof (source[field]) === 'number')
      .forEach((field) => {
        roundedTarget[field] = this.roundNumber(source[field], precision);
      });

    // instance of <T> with rounded fields
    return <T>roundedTarget;
  }

  /**
   * Round the the specified source number to specific precision.
   * @param source The number to round.
   * @param precision The number of significant digits.
   */
  roundNumber(source: number, precision: number): number {
    return Math.round(source * Math.pow(10, precision)) / Math.pow(10, precision);
  }
}
